import { normalizeUrl, replaceTokensInString } from '@app/utils';
import { GA_FORM_INVALID_SERIAL, GA_INVALID_SERAIL_SITES } from './constants';
import { headlessLinks } from '@app/constants/links';

/**
 * used to send GA data dynamically based on cookie value received for refApp
 *
 * @param {String} refApp cookie value received for refApp
 * @param {function} fireFormSubmittedEvent submitter method to send GA data
 */
export const sendGAInvalidSerialWithSites = (
  refApp,
  fireFormSubmittedEvent
) => {
  if (
    [
      GA_INVALID_SERAIL_SITES.visionLinkAppReference,
      GA_INVALID_SERAIL_SITES.qrCodeAppReference
    ].includes(refApp)
  ) {
    const siteData =
      refApp === GA_INVALID_SERAIL_SITES.visionLinkAppReference
        ? GA_INVALID_SERAIL_SITES.visionLinkSiteValue
        : refApp;
    fireFormSubmittedEvent({
      pagePath: document.location.pathname,
      formContent2: siteData,
      ...GA_FORM_INVALID_SERIAL
    });
  }
};

export const getCategoryURL = ({
  seoUrlKeyword,
  isHeadlessCategoriesEnabled,
  esiteURL
}) => {
  if (isHeadlessCategoriesEnabled) {
    const url = replaceTokensInString(
      headlessLinks.HEADLESS_CATEGORY_PAGE,
      esiteURL,
      seoUrlKeyword
    );
    return url;
  } else {
    return normalizeUrl(`${esiteURL}/${seoUrlKeyword}`);
  }
};
